export enum EState {
    ACT = 'ACT',
    NSW = 'NSW',
    NT = 'NT',
    QLD = 'QLD',
    SA = 'SA',
    TAS = 'TAS',
    VIC = 'VIC',
    WA = 'WA',
}

// New Zealand regions
export enum ENZRegion {
    AUCKLAND = 'Auckland',
    WELLINGTON = 'Wellington',
    CANTERBURY = 'Canterbury',
    WAIKATO = 'Waikato',
    BAY_OF_PLENTY = 'Bay of Plenty',
    OTAGO = 'Otago',
    MANAWATU_WANGANUI = 'Manawatu-Wanganui',
    HAWKES_BAY = "Hawke's Bay",
    TARANAKI = 'Taranaki',
    SOUTHLAND = 'Southland',
    NELSON = 'Nelson',
    NORTHLAND = 'Northland',
    GISBORNE = 'Gisborne',
    MARLBOROUGH = 'Marlborough',
    TASMAN = 'Tasman',
    WEST_COAST = 'West Coast',
}

// Unified state/region type for both AU and NZ
export type EStateOrRegion = EState | ENZRegion;

export enum ECreditRating {
    POOR = 'POOR',
    DECENT = 'DECENT',
    GREAT = 'GREAT',
}
